import { UIRouterGlobals } from "@uirouter/angular";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { takeUntil } from "rxjs";
import { DestroyService } from "@webapp/core/util/services/destroy.service";
import { CheckInNotification } from "@webapp/reflections/models/checkins-models";
import { ReflectionScheduleCadence } from "@webapp/reflections/models/reflections.models";
import { CheckInsFacade } from "@webapp/reflections/services/checkins-facade.service";

@Component({
  selector: "manage-reflection-schedule",
  templateUrl: "./manage-reflection-schedule.component.html",
  styleUrls: ["./manage-reflection-schedule.component.less"],
  providers: [DestroyService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ManageReflectionScheduleComponent implements OnInit {
  public days: ReflectionScheduleCadence[] = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
  public checkInNotificationSettings: CheckInNotification;
  public settingsId: string;

  constructor(private checkInsFacade: CheckInsFacade, private routerGlobals: UIRouterGlobals, private cdr: ChangeDetectorRef, private destroy$: DestroyService) {}

  public ngOnInit(): void {
    const reqFilter = {
      filter: { teamId: { $in: [this.routerGlobals.params["teamId"]] } },
    };

    this.checkInsFacade
      .getCheckInSettings$(reqFilter)
      .pipe(takeUntil(this.destroy$))
      .subscribe((settings) => {
        const { items: [checkInSettings = null] = [] } = settings;
        this.settingsId = checkInSettings.id;
        this.checkInNotificationSettings = checkInSettings.notifications;
        this.cdr.detectChanges();
      });
  }

  public onToggleCheckInNotifications(isEnabled: boolean): void {
    this.updateCheckInNotificationSettings({ isEnabled, day: this.checkInNotificationSettings.day });
  }

  public onNotificationDayChange(day: ReflectionScheduleCadence): void {
    this.updateCheckInNotificationSettings({ isEnabled: this.checkInNotificationSettings.enabled, day });
  }

  private updateCheckInNotificationSettings(params: { isEnabled: boolean; day: ReflectionScheduleCadence | string }): void {
    this.checkInsFacade
      .patchCheckInSettings$({
        payload: { notifications: { enabled: params.isEnabled, day: params.day } },
        settingsId: this.settingsId,
      })
      .pipe(takeUntil(this.destroy$))
      .subscribe((settings) => {
        this.checkInNotificationSettings = settings.notifications;
        this.cdr.detectChanges();
      });
  }
}
